import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import * as api from './api';
import * as types from './actionTypes';

/**
 * Get entities dictionaries
 *
 * @param paginationParams
 * @param filterParams
 */
export const getEntitiesDictionariesList = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: types.GET_ENTITIES_DICTIONARIES_REQUEST,
    });

    const { data } = await api.getDictionariesRequest(params);

    dispatch({
      type: types.GET_ENTITIES_DICTIONARIES_SUCCESS,
      payload: {
        items: data.results,
        count: data.count,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_ENTITIES_DICTIONARIES_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

export const getEntitiesConnectedDictionariesList = (
  params = {},
) => async dispatch => {
  try {
    dispatch({
      type: types.GET_ENTITIES_CONNECTED_DICTIONARIES_REQUEST,
    });

    const { data } = await api.getDictionariesRequest(params);

    dispatch({
      type: types.GET_ENTITIES_CONNECTED_DICTIONARIES_SUCCESS,
      payload: {
        items: data.results,
        count: data.count,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_ENTITIES_CONNECTED_DICTIONARIES_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};
